export const GROUP_COLLIDE = 2 ** 0;
export const GROUP_CURSOR = 2 ** 1;
